export default "__VITE_ASSET__CrNwePkT__"